import axios from 'axios'
import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, success } from '../../shared/constants'
import urlSearchParams from '../../components/urlSearchParams'
import { useDownload } from '../../hooks/Download/useDownload'

export const useChannelType = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const { addNewChannelType, editNewChannelType, deleteNewChannelType, getNewChannelTypes } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  // const [pdfCsvData, setPdfCsvData] = useState([])
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();

  const getAllChannelType = async (dto= {}) => {
    setLoading(true)
    axios
    .get(API.GET_CHANNEL_TYPE_MASTER, header)
      // .get(API.GET_CHANNEL_TYPE_MASTER, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        getNewChannelTypes(data.data)
        // setChannelTypes(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getAllChannelTypeWithParams = async (dto= {}) => {
    setLoading(true)
    axios
    .get(API.GET_CHANNEL_TYPES(urlSearchParams(dto)), header)
      // .get(API.GET_CHANNEL_TYPE_MASTER, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        // setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })
        getNewChannelTypes(data.data)
        getPdfCsvData('GET_CHANNEL_TYPES', {...dto, download : true})
        // setChannelTypes(data.data)
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addChannelType = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_CHANNEL_TYPE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('ChannelType Added Successfully', success)
        addNewChannelType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  return {
    addChannelType,
    getAllChannelType,
    getAllChannelTypeWithParams,
    loading,
    pdfCsvData
  }
}
